import { createForOfIteratorHelper as _createForOfIteratorHelper, toConsumableArray as _toConsumableArray } from './_virtual/_rollupPluginBabelHelpers.mjs';
import { DISASSEMBLED_CONSONANTS_BY_CONSONANT, DISASSEMBLED_VOWELS_BY_VOWEL } from './constants.mjs';
import { disassembleCompleteHangulCharacter } from './disassembleCompleteHangulCharacter.mjs';

function disassembleHangulToGroups(str) {
  /*
   * FIXME(@raon0211):
   * Array#map을 사용하는 경우 Safari에서 'Array size is not a small enough positive integer' 오류가 발생함.
   * 우선 map을 사용하지 않음으로써 문제를 회피함
   * @see https://sentry.io/organizations/toss/issues/2432344954/?project=1242586&referrer=slack
   * @see https://bugs.webkit.org/show_bug.cgi?id=211619
   */
  var result = [];

  var _iterator = _createForOfIteratorHelper(str),
      _step;

  try {
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var letter = _step.value;
      var disassembledComplete = disassembleCompleteHangulCharacter(letter);

      if (disassembledComplete != null) {
        result.push([].concat(_toConsumableArray(disassembledComplete.first), _toConsumableArray(disassembledComplete.middle), _toConsumableArray(disassembledComplete.last)));
        continue;
      }

      var disassembledConsonant = DISASSEMBLED_CONSONANTS_BY_CONSONANT[letter];

      if (disassembledConsonant != null) {
        result.push(_toConsumableArray(disassembledConsonant));
        continue;
      }

      var disassembledVowel = DISASSEMBLED_VOWELS_BY_VOWEL[letter];

      if (disassembledVowel != null) {
        result.push(_toConsumableArray(disassembledVowel));
        continue;
      }

      result.push([letter]);
    }
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }

  return result;
}
function disassembleHangul(str) {
  return disassembleHangulToGroups(str).reduce(function (hanguls, disassembleds) {
    return "".concat(hanguls).concat(disassembleds.join(''));
  }, '');
}

export { disassembleHangul, disassembleHangulToGroups };
